import * as Yup from "yup";

export const faqValidation = Yup.object().shape({
  title: Yup.string().required("وارد کردن عنوان الزامی است"),
  // answer: Yup.string().required("وارد کردن پاسخ الزامی است"),
  part: Yup.string().required("وارد کردن بخش الزامی است"),
});
